/* PROJ-88 Herz-Kette (ILB45) — Engine (3 Front-Modi + Rueckseiten-Text).
 * GETEILT: byte-identisch in distantlines/assets/ und shared_frontend/ auf
 * dem Render-Server (Parity-Gate tools/jewelry-parity.mjs, Eintrag SHARED).
 *
 * Haengt an jewelry-engine.js (muss VORHER geladen sein): nutzt
 * window.jewelryFontDefs (Gravurschrift 'DL Gravur' = Jost Light).
 *
 * Klassisches Script, KEINE ES-Imports/-Exports, synchron und DOM-frei
 * (Server-Print-Mode und Theme-Modul laden es gleich). Deshalb liest diese
 * Datei die Herz-Kontur NICHT aus jewelry-herz-kontur.js (ES-Modul) — die
 * Kontur gehoert dem Server-Clipping, der 3D-Buehne und dem Ausricht-Pfad.
 * Hier steckt die Kontur nur als KONSERVATIVE Layout-Reserve in den
 * Konstanten (siehe GEOMETRIE) — was rausragt, clippt der Server hart weg.
 *
 * config (configJson() aus jewelry-herz.js):
 *   { produkt: 'herz-kette', version: 1, farbe: 'silber'|'gold',
 *     modus: 'initialen'|'datum'|'symbol',
 *     initialen: { links: 'A', rechts: ''|'M',
 *                  trenner: 'keins'|'herz'|'infinity'|'pfote' },  // nur modus=initialen
 *     datum: 'YYYY-MM-DD',                                        // nur modus=datum
 *     symbol: 'herz'|'infinity'|'pfote',                          // nur modus=symbol
 *     rueckseite: 'freier Text'|'' }
 *
 * GEOMETRIE (viewBox 1024; die ILB45-Herz-Bbox ist 1024 breit x 944 hoch,
 * y 40..984, Kerbgrund in der Mitte bei y 220, Spitze bei y 984 —
 * kanonisch in jewelry-herz-kontur.js):
 *   - Alles Motiv sitzt um MOTIV_CY 500 (nicht 512): das Herz traegt oben
 *     mehr Flaeche als unten, die optische Mitte liegt leicht ueber der
 *     Bbox-Mitte.
 *   - Nutzbarer Kern (mit der kanonischen Kontur nachgerechnet 30.08.,
 *     Punkt-in-Polygon gegen die Zeichen-Bboxen): halbe Breite 486 px bei
 *     y 500, 417 bei y 620, 351 bei y 700 — nach unten verjuengt sich das
 *     Herz schnell. Deshalb sind ALLE Groessen hier konservativer als beim
 *     runden Coin, und die Rueckseite fittet auf HERZ_FIT_BREITE 620 statt
 *     820 (bei 820 lief die 3. Zeile aus der Kontur — nachgerechnet, nicht
 *     geschaetzt).
 *   - VORNE, 3 Modi (Momenterie-Referenz `necklace-heart`):
 *     initialen  1 Buchstabe gross mittig (330 px) oder 2 Buchstaben
 *                nebeneinander (230 px), dazwischen optional ein kleines
 *                Trenner-Symbol (~90 px Box).
 *     datum      TT.MM.JJJJ einzeilig mittig, Groesse aus der Fit-Rechnung
 *                (Notnagel textLength wie jewelry-engine.js backSVG).
 *     symbol     EIN Symbol gross mittig auf (512, 495).
 *   - Symbole aus dem LINIEN-KIT, Assets 1:1 aus jewelry-letters-engine.js
 *     (Herz = Umriss-Pfad der Sternenhimmel-Kette, Infinity = Jost-Glyph
 *     U+221E, Pfote = Lucide paw-print auf Kit-Strichstaerke).
 *     ⚠️ Die Herz-Form liegt jetzt in DREI Engines (jewelry-engine.js ~Z. 285,
 *     jewelry-letters-engine.js HERZ_PFAD, hier) — bei Aenderungen am Herz
 *     ALLE DREI anfassen, sonst driften Vorschau und Gravur.
 *   - HINTEN: freier Text, max. RUECK_MAX Zeichen, 1-3 Zeilen, Fit-Leiter
 *     1:1 aus jewelry-letters-engine.js (nur FIT-Breite herzspezifisch).
 *     Harte Mindestgroesse RUECK_MIN 58 px ≈ 0,65 mm Versal: was da nicht
 *     passt, lehnt das Gate ab. Final per Mustergravur am echten ILB45. */
(function (w) {
  'use strict';

  const INK = '#000';
  const CX = 512, CY = 512;
  /* Optische Mitte der Herzflaeche: leicht ueber der Bbox-Mitte (oben zwei
     Lobus-Baeuche, unten die Spitze). Gilt fuer alle Front-Modi. */
  const MOTIV_CY = 500;
  /* PROJ-107 (25.10.2026, Herzkette mit Datum als Coin): cfg.form 'coin' zeichnet dieselben Motive auf den runden
     Coin. Anker dann auf der Coin-Mitte 512 statt 500, Rueckseiten-Fit 820 wie die Coin-Geschwister. Herz bleibt
     byte-gleich (MY = MOTIV_CY, FIT = HERZ_FIT_BREITE). */
  let MY = MOTIV_CY;
  const GRAVUR = "'DL Gravur', 'Jost', sans-serif";
  /* Buchstaben der Initialen-Modi: Poppins Light als 'DL Initialen' (jewelry-engine.js, PROJ-104, 04.10.2026);
     Symbole, Datum und Rueckseite bleiben GRAVUR. */
  const INITIALEN = "'DL Initialen', 'Poppins', sans-serif";
  const VERSAL = 0.72;      /* Versalhoehe Jost Light in em (Schaetzung) — Rueckseiten-Text, unveraendert */
  const INITIALEN_VERSAL = 0.70;  /* Versalhoehe Poppins Light in em (OS/2 sCapHeight 700 / 1000) — nur die Initialen-Buchstaben */

  /* ---------- Symbol-Kit (Assets 1:1 aus jewelry-letters-engine.js) ---------- */
  const SYMBOL_KEYS = ['herz', 'infinity', 'pfote'];
  const HERZ_PFAD = 'M-15 0 c-5-10 5-18 15-8 c10-10 20-2 15 8 c-4 8-15 15-15 15 c0 0-11-7-15-15 z';
  const HERZ_SCALE = 4.6;   /* Box ~138 px — Referenzgroesse des Kits */
  /* Dominik 11.10.2026: Pfote und Unendlich gefuellt aus seinen Vektor-Downloads, auf die Herz-Box normiert
     (identische Pfade wie jewelry-letters-engine.js): Pfote 32.3 x 27.6, Unendlich 42.0 x 19.14 Einheiten, Skala = HERZ_SCALE. */
  const INFINITY_PFAD = 'M-18.43 -12.52C-25.87 -10.93 -30.28 -3.69 -28.08 3.32C-25.73 10.79 -17.13 13.80 -10.17 9.60C-8.16 8.39 -7.07 7.35 -2.83 2.65L-2.35 2.12L0.61 4.73C7.12 10.44 9.49 11.64 13.99 11.46C25.02 11.05 30.28 -2.11 22.42 -9.57C18.50 -13.28 12.63 -13.80 7.70 -10.83C5.68 -9.63 4.61 -8.62 0.36 -3.88L-0.12 -3.35L-3.07 -5.96C-8.32 -10.57 -10.43 -11.90 -13.45 -12.52C-14.71 -12.79 -17.20 -12.79 -18.43 -12.52ZM15.33 -11.03C22.05 -9.55 24.99 -1.92 20.91 3.48C18.18 7.08 13.57 7.61 9.34 4.80C7.64 3.69 0.87 -2.21 0.97 -2.45C1.02 -2.65 4.76 -6.79 5.80 -7.82C8.70 -10.73 11.85 -11.80 15.33 -11.03ZM-15.24 -7.66C-13.68 -7.25 -11.97 -6.29 -10.02 -4.74C-8.90 -3.85 -3.40 1.10 -3.40 1.20C-3.42 1.56 -9.00 7.40 -10.11 8.19C-16.38 12.68 -25.24 8.35 -25.24 0.81C-25.24 -4.74 -20.26 -8.95 -15.24 -7.66Z';
  const PFOTE_PFAD = 'M-6.06 -12.91C-9.62 -12.05 -9.26 -5.10 -5.54 -3.30C-3.17 -2.15 -0.98 -4.03 -0.99 -7.21C-1.00 -10.61 -3.58 -13.51 -6.06 -12.91ZM4.22 -12.89C1.10 -12.07 -0.56 -6.98 1.41 -4.22C2.79 -2.30 5.41 -2.65 6.97 -4.96C9.47 -8.65 7.68 -13.80 4.22 -12.89ZM-13.25 -6.42C-15.89 -5.62 -16.15 -1.67 -13.76 1.17C-11.97 3.29 -9.23 3.67 -7.97 1.97C-6.10 -0.54 -8.00 -5.22 -11.33 -6.34C-11.83 -6.51 -12.82 -6.55 -13.25 -6.42ZM11.33 -6.45C8.44 -5.85 6.18 -2.06 6.98 0.82C7.57 2.92 9.74 3.67 11.78 2.48C15.41 0.34 16.15 -5.25 12.96 -6.38C12.66 -6.48 11.68 -6.53 11.33 -6.45ZM-0.68 -1.40C-0.72 -1.39 -0.91 -1.36 -1.10 -1.33C-3.95 -0.87 -7.41 2.27 -9.33 6.17C-10.73 9.01 -10.84 10.86 -9.68 12.10C-8.27 13.61 -6.38 13.80 -2.69 12.79C-0.17 12.10 -0.25 12.10 2.27 12.79C5.21 13.59 6.76 13.64 8.13 12.94C10.40 11.81 10.64 9.68 8.91 6.17C7.02 2.34 3.74 -0.69 0.82 -1.31C0.50 -1.38 -0.52 -1.44 -0.68 -1.40Z';

  /* Faktoren auf die Kit-Referenzgroesse. Trenner ~0,65 => Box ~90 px
     (passt zwischen zwei 230er-Buchstaben). Grosses Symbol ~3x — ausser dem
     ∞: das ist ein FLACHES, breites Glyph, bei 3,0 spannte es ueber fast die
     ganze nutzbare Breite und wirkte im Rendering-Vergleich gegen das
     Umriss-Herz klobig (Herz 3,0 = 414 px breit, ∞ 3,0 = 720 px). 2,3 legt
     es auf ~500 px Breite und dieselbe Strich-Liga. Gemessen am
     Kontur-Rendering, nicht geschaetzt (30.08.). */
  const SYM_TRENNER = 0.65;
  const SYM_GROSS = { herz: 3.0, infinity: 2.3, pfote: 3.0 };
  const SYMBOL_CY = 495;    /* Herz; Coin: 507 (gleicher Versatz zur Mitte) */    /* Anker des grossen Einzelsymbols */

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* faktor skaliert das ganze Symbol inkl. Strichstaerke (der Strich haengt
     bei Herz/Pfote am transform-scale, beim ∞ an der font-size) — dadurch
     bleiben Trenner und grosses Symbol in derselben Zeichen-Liga. */
  function symbolSVG(key, ax, ay, faktor) {
    const f = faktor || 1;
    if (key === 'herz') {
      const s = HERZ_SCALE * f;
      return `<path transform="translate(${ax} ${ay}) scale(${s.toFixed(3)})" d="${HERZ_PFAD}" fill="none" stroke="${INK}" stroke-width="2.2" stroke-linejoin="round"/>`;
    }
    const s = HERZ_SCALE * f;
    if (key === 'infinity')
      return `<path transform="translate(${ax} ${ay}) scale(${s.toFixed(3)})" d="${INFINITY_PFAD}" fill="${INK}"/>`;
    /* pfote: gefuellt, Mitte auf dem Anker, gleiche Skala wie das Herz. */
    return `<path transform="translate(${ax} ${ay}) scale(${s.toFixed(3)})" d="${PFOTE_PFAD}" fill="${INK}"/>`;
  }

  /* ---------- Modus 1: Initialen ---------- */
  const BUCHST_GR_1 = 330;  /* ein Buchstabe, gross mittig */
  const BUCHST_GR_2 = 230;  /* zwei Buchstaben nebeneinander */
  const ANKER_2 = 130;      /* halber Abstand der Buchstaben-Anker, ohne Trenner */
  const ANKER_2_TRENNER = 175; /* mit Trenner: Luecke fuer das ~90er Symbol */

  /* ---------- Schriftwahl vorne (PROJ-116, 25.10.2026, Dominik: „wenn das Design vorne ist, dann muss es da auch
     eine Font-Auswahl geben“) ----------
     cfg.schrift: fehlt oder 'modern' = Schrift des Designs wie bisher (byte-gleich, Golden-Test
     tools/initialen-linie-check.mjs), sonst ein Schluessel aus jewelry-abdruck-schriften.js (dieselben fuenf
     Schriften wie die Rueckseite, gemessene Breiten + Tintenkaesten). Jede Schrift bekommt dieselbe Versalhoehe
     wie die Standardschrift (Oberkante des H), wird bei breiten Glyphen auf die freie Breite gedeckelt (maxB)
     und sitzt mit der Mitte ihres Tintenkastens auf dem Anker. Unbekannte Schluessel = Standard (der Server
     lehnt sie ab). */
  let FRONT_SCH = null;
  function frontSchrift(cfg) {
    const k = cfg && cfg.schrift;
    if (!k || k === 'modern') return null;
    const tab = w.JEWELRY_ABDRUCK_SCHRIFTEN;
    return tab && Object.prototype.hasOwnProperty.call(tab, k) ? tab[k] : null;
  }
  function frontSchriftDefs(S) {
    return `<defs><style>@font-face{font-family:'${S.familie}';src:url(data:font/woff2;base64,${S.woff2}) format('woff2');font-weight:400;font-style:normal;}</style></defs>`;
  }
  /* Alle Buchstaben einer Seite teilen Groesse und Grundlinie (sonst stuende ein Cinzel-J tiefer als das A daneben):
     FRONT_TEXTE haelt alle Texte der Seite, Breiten-Deckel und Tintenkasten gelten fuer die ganze Gruppe. */
  let FRONT_TEXTE = [];
  /* Tinte eines Textes in em relativ zum Ursprung: [links, rechts]. Erste und letzte Glyphe mit ihrer echten Kante
     (S.tinte, aus der Font gelesen), dazwischen die Vorschuebe. Fehlt ein Wert, gilt der Vorschub. */
  function frontTinte(S, t) {
    const z = [...t];
    if (!z.length) return [0, 0];
    const adv = ch => (S.breiten[ch] != null ? S.breiten[ch] : 0.7);
    const ti = ch => (S.tinte && S.tinte[ch]) || [0, adv(ch)];
    let vor = 0;
    for (let i = 0; i < z.length - 1; i++) vor += adv(z[i]);
    return [ti(z[0])[0], vor + ti(z[z.length - 1])[1]];
  }
  function frontSchriftText(S, t, ax, ay, versal, maxB) {
    const obenH = (S.kasten && S.kasten.H ? S.kasten.H[1] : 0.7);
    let gr = versal / obenH;
    const gruppe = FRONT_TEXTE.length ? FRONT_TEXTE : [t];
    let emMax = 0, unten = 0, oben = 0;
    for (const g of gruppe) {
      const [l, r] = frontTinte(S, g);
      emMax = Math.max(emMax, r - l);
      for (const ch of g) {
        const k = S.kasten && S.kasten[ch];
        if (k) { unten = Math.min(unten, k[0]); oben = Math.max(oben, k[1]); }
      }
    }
    /* maxB = erlaubte TINTEN-Breite: Mitte auf dem Anker, Rand mit 40 Einheiten (0,62 mm) Abstand zu Linie/Herz. */
    if (emMax * gr > maxB) gr = maxB / emMax;
    if (!oben) oben = obenH;
    const y = ay + (unten + oben) / 2 * gr;
    const [l, r] = frontTinte(S, t);
    const x = ax - (l + r) / 2 * gr;
    return `<text x="${x.toFixed(1)}" y="${y.toFixed(1)}" font-family="'${S.familie}', ${INITIALEN}" font-size="${gr.toFixed(1)}" fill="${INK}">${esc(t)}</text>`;
  }

  function buchstabeSVG(ch, ax, ay, gr, maxB) {
    if (FRONT_SCH) return frontSchriftText(FRONT_SCH, ch, ax, ay, gr * INITIALEN_VERSAL, maxB || 520);
    /* Optische Mitte auf dem Anker: Grundlinie eine halbe Versalhoehe
       unterhalb (Muster roemische Ziffern, jewelry-birth-engine). */
    const y = ay + gr * INITIALEN_VERSAL / 2;
    return `<text x="${ax}" y="${y.toFixed(1)}" font-family="${INITIALEN}" font-size="${gr}" text-anchor="middle" fill="${INK}">${esc(ch)}</text>`;
  }

  function normBuchstabe(v) {
    const s = String(v || '').trim().toUpperCase();
    return /^[A-Z]$/.test(s) ? s : '';
  }

  /* ---------- Trenner 'linie' (PROJ-104 Design „A | B“ auf dem Herz, 29.09.2026) ----------
     Eigenes Design-Produkt (Trenner fest). Proportionen der Mizodia-Vorlage relativ zur
     Versalhoehe uebertragen: Anker = 0,998 x Versal (22,6 / 22,65 von d), Linie = 1,907 x Versal
     (43,2 / 22,65 von d). Buchstabengroesse wie „A ♥ M“ (BUCHST_GR_2 = 230), Versalhoehe aus der
     Font GELESEN (0,700 em, nicht die Schaetzung VERSAL): 161. Buchstaben A-Z plus Ä, Ö, Ü nur
     bei diesem Trenner. Passt ganz in die Herzflaeche (W, M, Ä und Linie gegen die Herz-Maske
     geprueft, tools/initialen-linie-check.mjs). */
  const LINIE_VERSAL = BUCHST_GR_2 * 0.700;              /* 161 */
  const LINIE_ANKER = Math.round(0.998 * LINIE_VERSAL);  /* 161 */
  const LINIE_HALB = 1.907 * LINIE_VERSAL / 2;           /* 153,5: Linie 307 lang */
  const LINIE_STRICH = 10;                               /* Linien-Familie */

  function normLinieBuchstabe(v) {
    const s = String(v || '').trim().toUpperCase();
    return /^[A-ZÄÖÜ]$/.test(s) ? s : '';
  }
  function normInitialen(cfg) {
    const i = cfg.initialen || {};
    const trenner = SYMBOL_KEYS.indexOf(i.trenner) !== -1 || i.trenner === 'linie' ? i.trenner : 'keins';
    const norm = trenner === 'linie' ? normLinieBuchstabe : normBuchstabe;
    return { links: norm(i.links), rechts: norm(i.rechts), trenner };
  }

  function linieInitialenSVG(ini) {
    const y = (MY + LINIE_VERSAL / 2).toFixed(1);
    const buchstabe = (ch, x) => ch && FRONT_SCH ? frontSchriftText(FRONT_SCH, ch, x, MY, LINIE_VERSAL, 232) : ch
      ? `<text x="${x}" y="${y}" font-family="${INITIALEN}" font-size="${BUCHST_GR_2}" text-anchor="middle" fill="${INK}">${esc(ch)}</text>`
      : '';
    let s = `<line x1="${CX}" y1="${(MY - LINIE_HALB).toFixed(1)}" x2="${CX}" y2="${(MY + LINIE_HALB).toFixed(1)}" stroke="${INK}" stroke-width="${LINIE_STRICH}" stroke-linecap="round"/>`;
    s += buchstabe(ini.links, CX - LINIE_ANKER);
    s += buchstabe(ini.rechts, CX + LINIE_ANKER);
    return s;
  }

  function initialenSVG(ini) {
    if (ini.trenner === 'linie') return linieInitialenSVG(ini);
    if (!ini.links && !ini.rechts) return '';
    /* Nur ein Buchstabe belegt (egal welches Feld): gross und mittig. Der
       Trenner ist dann bedeutungslos und faellt weg. */
    if (!ini.links || !ini.rechts)
      return buchstabeSVG(ini.links || ini.rechts, CX, MY, BUCHST_GR_1);
    const mitTrenner = ini.trenner !== 'keins';
    const dx = mitTrenner ? ANKER_2_TRENNER : ANKER_2;
    /* Schriftwahl (Tintenbreite, Mitte auf dem Anker, 40 Einheiten Abstand): mit Symbol (Kante 512 - 45 - 3 = 464)
       2 x (464 - 40 - 337) = 174, ohne Trenner 2 x (512 - 20 - 382) = 220. Linie (Kante 507): 2 x (507 - 40 - 351) = 232. */
    const maxB = mitTrenner ? 174 : 220;
    let s = buchstabeSVG(ini.links, CX - dx, MY, BUCHST_GR_2, maxB);
    s += buchstabeSVG(ini.rechts, CX + dx, MY, BUCHST_GR_2, maxB);
    if (mitTrenner) s += symbolSVG(ini.trenner, CX, MY, SYM_TRENNER);
    return s;
  }

  /* ---------- Modus 2: Datum ---------- */
  const DATUM_FIT = 620;    /* nutzbare Breite auf Hoehe der Datumszeile */
  const DATUM_MAX_GR = 150; /* Deckel, damit kurze Jahre nicht ausfransen */
  const ZIFFER_EM = 0.55, PUNKT_EM = 0.28;

  /* 'YYYY-MM-DD' -> 'TT.MM.JJJJ'; '' wenn das Datum nicht plausibel ist
     (der Server prueft verbindlich, hier nur Anzeige-Schutz). */
  function datumText(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    if (!m) return '';
    const jahr = Number(m[1]), monat = Number(m[2]), tag = Number(m[3]);
    if (monat < 1 || monat > 12 || tag < 1 || tag > 31) return '';
    return `${m[3]}.${m[2]}.${m[1]}`;
  }

  function datumSVG(text) {
    if (!text) return '';
    let em = 0;
    for (const ch of text) em += ch === '.' ? PUNKT_EM : ZIFFER_EM;
    const gr = Math.min(DATUM_MAX_GR, DATUM_FIT / em);
    if (FRONT_SCH) return frontSchriftText(FRONT_SCH, text, CX, MY, gr * VERSAL, DATUM_FIT);
    const y = MY + gr * VERSAL / 2;
    /* Notnagel wie jewelry-engine.js backSVG: sollte die Schaetzung je
       daneben liegen (andere Ziffernbreiten), presst textLength die Zeile
       hart in die Fit-Breite, statt sie aus der Kontur laufen zu lassen. */
    const not = gr * em > DATUM_FIT ? ` textLength="${DATUM_FIT}" lengthAdjust="spacingAndGlyphs"` : '';
    return `<text x="${CX}" y="${y.toFixed(1)}" font-family="${GRAVUR}" font-size="${gr.toFixed(1)}" text-anchor="middle" fill="${INK}"${not}>${esc(text)}</text>`;
  }

  /* ---------- Vorderseite ---------- */
  const MODI = ['initialen', 'datum', 'symbol'];
  function normModus(cfg) {
    return MODI.indexOf(cfg.modus) !== -1 ? cfg.modus : 'initialen';
  }
  function normSymbol(v) {
    return SYMBOL_KEYS.indexOf(v) !== -1 ? v : 'herz';
  }

  function frontSVG(cfg) {
    MY = cfg && cfg.form === 'coin' ? 512 : MOTIV_CY;
    FRONT_SCH = frontSchrift(cfg);
    const c = cfg || {};
    const modus = normModus(c);
    if (modus === 'datum') FRONT_TEXTE = [datumText(c.datum)].filter(Boolean);
    else if (modus === 'initialen') { const i = normInitialen(c); FRONT_TEXTE = [i.links, i.rechts].filter(Boolean); }
    else FRONT_TEXTE = [];
    try { return frontSVGInnen(cfg); } finally { FRONT_SCH = null; FRONT_TEXTE = []; MY = MOTIV_CY; }
  }
  function frontSVGInnen(cfg) {
    let s = w.jewelryFontDefs() + w.jewelryInitialenFontDefs() + (FRONT_SCH ? frontSchriftDefs(FRONT_SCH) : '');
    const modus = normModus(cfg || {});
    if (modus === 'datum') {
      s += datumSVG(datumText((cfg || {}).datum));
    } else if (modus === 'symbol') {
      const key = normSymbol((cfg || {}).symbol);
      s += symbolSVG(key, CX, MY === MOTIV_CY ? SYMBOL_CY : 507, SYM_GROSS[key]);
    } else {
      s += initialenSVG(normInitialen(cfg || {}));
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">${s}</svg>`;
  }

  /* ---------- Rueckseite: freier Text, 1-3 Zeilen ---------- */
  /* Logik 1:1 aus jewelry-letters-engine.js; herzspezifisch ist NUR die
     Fit-Breite (HERZ_FIT_BREITE statt FIT_BREITE 820). */
  const RUECK_MAX = 60;
  const RUECK_STUFEN = [84, 74, 66, 58];
  const RUECK_MIN = 58;
  const RUECK_ZEILEN_MAX = 3;
  /* 620 statt 820: der 3-Zeilen-Block reicht bis y ~672, dort ist das Herz
     nur noch ~2x377 px breit. Mit 820 lag die unterste Zeile ausserhalb der
     Kontur (gegen jewelry-herz-kontur.js nachgerechnet, 30.08.) und waere
     im Druck beschnitten worden. */
  const HERZ_FIT_BREITE = 620;
  const GLYPH_EM = 0.55;
  const ZEILE_EM = 1.35;    /* Zeilenabstand in em */

  function effLaenge(t) {
    let n = 0;
    for (const ch of t) n += /[A-ZÀ-ÞĄĆĘŁŃŚŹŻА-ЯЁ]/.test(ch) ? 1.3 : 1;
    return n;
  }
  let FIT = HERZ_FIT_BREITE;
  const zeilePasst = (t, gr) => effLaenge(t) * gr * GLYPH_EM <= FIT;

  /* Greedy-Umbruch an Wortgrenzen fuer eine feste Groesse; null wenn ein
     Einzelwort nicht passt oder mehr als RUECK_ZEILEN_MAX Zeilen noetig. */
  function umbruch(text, gr) {
    const worte = text.split(/\s+/).filter(Boolean);
    const zeilen = [];
    let akt = '';
    for (const wort of worte) {
      if (!zeilePasst(wort, gr)) return null;
      const test = akt ? akt + ' ' + wort : wort;
      if (zeilePasst(test, gr)) akt = test;
      else { zeilen.push(akt); akt = wort; }
    }
    if (akt) zeilen.push(akt);
    return zeilen.length <= RUECK_ZEILEN_MAX ? zeilen : null;
  }

  /* Groesste Stufe, bei der der Text in max. 3 Zeilen passt. null = zu lang. */
  function rueckLayout(text) {
    for (const gr of RUECK_STUFEN) {
      const zeilen = umbruch(text, gr);
      if (zeilen) return { gr, zeilen };
    }
    return null;
  }
  function rueckseiteZuLang(text, form) {
    const t = (text || '').trim().replace(/\s+/g, ' ');
    if (!t) return false;
    if ([...t].length > RUECK_MAX) return true;
    FIT = form === 'coin' ? 820 : HERZ_FIT_BREITE;
    try { return rueckLayout(t) == null; } finally { FIT = HERZ_FIT_BREITE; }
  }

  function backSVG(cfg) {
    FIT = cfg && cfg.form === 'coin' ? 820 : HERZ_FIT_BREITE;
    try { return backSVGInnen(cfg); } finally { FIT = HERZ_FIT_BREITE; }
  }
  function backSVGInnen(cfg) {
    let s = w.jewelryFontDefs();
    const t = ((cfg || {}).rueckseite || '').trim().replace(/\s+/g, ' ');
    if (t) {
      const lay = rueckLayout(t);
      if (lay) {
        const lh = lay.gr * ZEILE_EM;
        const n = lay.zeilen.length;
        for (let i = 0; i < n; i++) {
          /* Blockmitte auf der Herz-Mitte (CY, nicht MY: der Textblock
             ist symmetrisch und nutzt die Flaeche nach oben wie nach unten);
             Grundlinie je Zeile eine halbe Versalhoehe unter ihrer optischen
             Mitte. */
          const yMitte = CY + (i - (n - 1) / 2) * lh;
          const y = yMitte + lay.gr * VERSAL / 2;
          s += `<text x="${CX}" y="${y.toFixed(1)}" font-family="${GRAVUR}" font-size="${lay.gr}" text-anchor="middle" fill="${INK}">${esc(lay.zeilen[i])}</text>`;
        }
      }
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">${s}</svg>`;
  }

  w.jewelryHerzFrontSVG = frontSVG;
  w.jewelryHerzBackSVG = backSVG;
  w.jewelryHerzRueckseiteZuLang = rueckseiteZuLang;
  w.jewelryHerzRueckseiteMax = RUECK_MAX;
  w.jewelryHerzSymbole = SYMBOL_KEYS;
  w.jewelryHerzModi = MODI;
  w.jewelryHerzDatumText = datumText;
})(window);
